<template>
  <div>
    <b-modal
      v-model="dataModal.status"
      title="İşlem Detayı"
      centered
      size="lg"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <b-list-group v-if="dataModal.dataItem">
        <donation-group />
        <bank-account />
        <safe-account />
        <donate-date />
        <is-receipt />
        <notes-text />
        <amount />
        <data-saved />
        <b-list-group-item
          v-if="dataModal.dataItem.is_income"
          class="text-center"
        >
          <b-button
            variant="flat-danger"
            @click="openReceiptModal"
          >
            <FeatherIcon icon="PrinterIcon" />
            Makbuz Yazdır
          </b-button>
        </b-list-group-item>
      </b-list-group>
      <b-alert
        v-else
        show
      >
        <div class="alert-body text-center">
          <b-spinner />
          <div>Lütfen bekleyiniz...</div>
        </div>
      </b-alert>
    </b-modal>
    <b-modal
      v-model="receiptModal"
      title="Makbuz Oluştur"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div>
        <donor-name />
        <donor-phone />
        <donor-address />
        <div class="text-center">
          <b-button
            variant="success"
            @click="donorSave"
          >
            <FeatherIcon icon="PrinterIcon" />
            Yazdır
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {
  BModal, BListGroup, BListGroupItem, BAlert, BSpinner, BButton,
} from 'bootstrap-vue'
import DonationGroup from '@/views/Admin/Account_activities/Components/ViewModal/DonationGroup.vue'
import BankAccount from '@/views/Admin/Account_activities/Components/ViewModal/BankAccount.vue'
import SafeAccount from '@/views/Admin/Account_activities/Components/ViewModal/SafeAccount.vue'
import DonateDate from '@/views/Admin/Account_activities/Components/ViewModal/DonateDate.vue'
import IsReceipt from '@/views/Admin/Account_activities/Components/ViewModal/IsReceipt.vue'
import NotesText from '@/views/Admin/Account_activities/Components/ViewModal/Notes.vue'
import Amount from '@/views/Admin/Account_activities/Components/ViewModal/Amount.vue'
import DataSaved from '@/views/Admin/Account_activities/Components/ViewModal/DataSaved.vue'
import DonorName from '@/views/Admin/Account_activities/Components/ViewModal/ReceiptModal/DonorName.vue'
import DonorPhone from '@/views/Admin/Account_activities/Components/ViewModal/ReceiptModal/DonorPhone.vue'
import DonorAddress from '@/views/Admin/Account_activities/Components/ViewModal/ReceiptModal/DonorAddress.vue'

export default {
  name: 'ViewModal',
  components: {
    BModal,
    BListGroup,
    BListGroupItem,
    BAlert,
    BSpinner,
    BButton,
    DonationGroup,
    BankAccount,
    SafeAccount,
    DonateDate,
    IsReceipt,
    NotesText,
    Amount,
    DataSaved,
    DonorName,
    DonorPhone,
    DonorAddress,
  },
  data() {
    return {
      receiptModal: false,
    }
  },
  computed: {
    dataModal() {
      return this.$store.getters['accountActivities/dataModal']
    },
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
  },
  methods: {
    openReceiptModal() {
      this.receiptModal = true
    },
    donorSave() {
      this.$store.dispatch('accountActivities/donorSaveData', {
        id: this.dataModal.dataItem.id,
        donor_name: this.dataItem.donor_name,
        donor_phone: this.dataItem.donor_phone,
        donor_address: this.dataItem.donor_address,
      })
        .then(response => {
          if (response.status) {
            window.open(`${this.$store.state.app.baseURL}/Exports/receipt/pdf?id=${response.id}`, '_blank')
          }
        })
    },
  },
}
</script>
